// CustomSelect.tsx
import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import TypoGraphyKit from "../../kit/typoGraphy";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";

interface CustomSelectProps {
  label: string;
  value: string;
  onChange: (event: SelectChangeEvent, item?: any) => void;
  options: any;
  width?: string;
  getOptionLabel: (item: any) => string;
  getOptionValue: (item: any) => string;
  className?: string; // make it optional
}

function CustomSelectNormal({
  label,
  value,
  onChange,
  options,
  getOptionLabel,
  getOptionValue,
  width = "100%",
  className = "", // default empty string
}: CustomSelectProps) {
  return (
    <FormControl
      className={`${className} !m-0`} // 👈 Tailwind class support added
      sx={{
        width,
        background:
          "linear-gradient(91.84deg, rgba(255, 255, 255, 0.123) -11.9%, rgba(255, 255, 255, 0.0497474) 80.85%, rgba(255, 255, 255, 0.027) 109.66%)",
        borderRadius: "8px",
      }}
    >
      {label && <InputLabel id={`${label}-label`}>{label}</InputLabel>}

      <Select
        labelId={`${label}-label`}
        value={value}
        label={label}
        onChange={onChange}
        sx={{ color: "#fff" }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#121212",
              color: "#fff",
            },
          },
        }}
      >
        {options?.map((item: any, idx: number) => (
          <MenuItem key={idx} value={getOptionValue(item)}>
            <TypoGraphyKit variant="body1">
              {toPersianNumber(getOptionLabel(item))}
            </TypoGraphyKit>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default CustomSelectNormal;
